exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".StickyPlayer {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 40;\n  transition: transform 0.5s; }\n  .StickyPlayer:not(.is-visible) {\n    transform: translateY(100%); }\n  .StickyPlayer-inner {\n    max-width: 1080px;\n    margin-left: auto;\n    margin-right: auto; }\n    .StickyPlayer-inner:after {\n      content: \" \";\n      display: block;\n      clear: both; }\n", ""]);

// exports
